'use strict'

import { DOM } from './../ui/DOM.js'
import { showToast } from './../ui/Toast.js'

/**
 * Handles saving the current project and related info with standard toasts.
 */
class SaveProjectHandler {
    /**
     * @param {Object} application - Visualizer Application instance.
     * @param {Function} [stripPrepaintParams] - Callback to remove prepaint query params post-save.
     */
    constructor(application, stripPrepaintParams) {
        this.app = application
        this.stripPrepaintParams = stripPrepaintParams
    }

    /**
     * Persist the project and its metadata.
     * Ensures a project exists (via ensureProjectExists) before saving if ids are missing.
     * @returns {Promise<boolean>} true on success, false on failure.
     */
    async saveProjectAndInfos() {
        const app = this.app
        DOM.loading(true)
        showToast('saving')
        try {
            const hasIds = app.project?.id && app.dataProject?.photos?.[0]?.id
            if (!hasIds && app.ensureProjectExists) {
                await app.ensureProjectExists()
            }

            await app.saveProject()
            await app.saveProjectInfos()

            showToast('saved')
            this.stripPrepaintParams?.()
            return true
        } catch (err) {
            console.error('[SaveProjectHandler] save failed:', err)
            showToast('error')
            return false
        } finally {
            DOM.loading(false)
        }
    }
}

export default SaveProjectHandler
